import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Suaje, SuajeService } from '../../services/suaje.service';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { toast, MaterializeAction } from 'angular2-materialize';
import { ProductClientService } from '../../services/product-client.service';

@Component({
  selector: 'app-read-suaje',
  templateUrl: './read-suaje.component.html',
  styleUrls: ['./read-suaje.component.css']
})
export class ReadSuajeComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loading: boolean[] = [false, false, true];
  get loaded(): boolean { return !this.loading.includes(false); }

  suajes: any[] = [];
  prClients: any[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Código', name: 'name'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Largo x Ancho x Alto', name: 'size'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'show', title: '', styleIcon: 'open_with', action: 'onShow', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
      onShow: this.onShow.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  suajeSub: Subscription;

  constructor(
    private service: SuajeService,
    private prClientService: ProductClientService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    let setSub = this.settings.getPayrollSettings('1').subscribe(setting => {
      setSub.unsubscribe();
      this.loading[0] = true;
      this.itemsPerPage = setting.tableQuantity;
    });
		this.suajeSub = this.service.getSuajes({onEmpty: ()=>{ this.loading[1] = true; }}).subscribe(tempSuajes => {
			this.suajes = tempSuajes.map(suaje => {
        suaje.name = suaje.code;
        suaje.customerName = suaje.customerObj.name;
        suaje.size = `${suaje.long} x ${suaje.wide} x ${suaje.height}`;
        return suaje;
      })
      this.data = this.suajes;
			this.length = this.data.length;
			this.onChangeTable(this.config);
      this.loading[1] = true;
    });
	}

  ngOnInit() {
  }
  ngOnDestroy(){
    this.suajeSub.unsubscribe();
  }

  deleteSuaje(sid: string) {
    this.service.deleteSuaje(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_suaje']);
  }

  onShow({row: {code, customerObj: {id: customerId}}}){
    this.prClients = [];
    this.loading[2] = false;
    let sub = this.prClientService.getPrClients({customerId, onEmpty: () => {
      this.loading[2] = true;
      toast('No se encontraron productos de cliente.', 3000);
    }, }).subscribe((prClients=[]) => {
      sub.unsubscribe();
      this.loading[2] = true;
      this.prClients = prClients.filter(({sections}) => {
        let bool = false;
        sections.map(({activities}) => {
          activities.map(({unique:{suajeDescription=''}=<any>{}}) => {
            if(suajeDescription.split(' - ')[0] == code) bool = true;
          });
        });
        return bool;
      });
      if(this.prClients.length) this.openModalShow();
      else toast('No se encontraron productos de cliente.', 3000);
    });
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.service.windowReplace('edit', data.row.id);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deleteSuaje(data.row.id);
  }
  
  /////////////////////////////////////////////////////////////////////////////////////////////////SHOW
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  openModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////SHOW

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
